import React from "react";
// import MainPageFooter from '../Components/MainPageFooter'
import NavBar from "../Components/navbar";
import "../Components/Styling/OurTeam.css";
import styles from "../Components/Styling/contactPage.module.css";
import { FaLocationArrow } from "react-icons/fa";
import { FaPhone, FaXRay, FaMailBulk } from "react-icons/fa";
import Footer from "../Components/footer";
const OurTeam = () => {
  return (
    <>
      <NavBar />
      <div className="container22">
        <h1 className="heading-team">Management Team</h1>
        <div className="borderBottom-team"></div>
        <div className="profiles-team">
          <div className="row profile-team">
            <div className="col-sm3 member-pic">
              <img
                src={require("../imgs/kayan-ceo.jpg")}
                alt="islam"
                className="profile-img"
              />
            </div>
           
            <div className="col-sm6 member-info">
              <h3 className="user-name-team">Islam Hijawi</h3>
              <h5>General Manager</h5>
              <p>
                Islam Hijawi is the Owner and Managing Director
                {/*  of Kayan
                Healthcare */}
                . An effective leader with excellent management skills that
                promote productivity towards achieving project and
                organizational goals. Islam is holding a High Diploma in
                Management, master’s degree in public health and Strategic
                Planning, and Bachelor of Physiotherapy. Finally, Islam speaks
                Arabic and English.
              </p>
            </div>
          </div>
       
       
        
        </div>
        <h1 id="contact" className="heading-team">
          offices
        </h1>
        <div className="borderBottom"></div>
        <div className={styles.row} style={{ textAlign: "left" }}>
          <div className={styles.column}>
            <h3 className={styles.header}>UAE</h3>
            <ul className="list-unstyled">
              <li className={styles.content}>
                <FaLocationArrow className="footer-icon-team" />
                Address
              </li>
              <li>
                Dubai, Sheikh Zayed Road, Aspin Commercial Tower, 44th Floor
              </li>
            {/*   <li className={styles.content}>
                <FaMailBulk className="footer-icon-team" />
                Email
              </li> */}
              {/*  <li>ihijawi@kayan-healthcare.com</li> */}
            {/*   <li className={styles.content}>
                <FaPhone className="footer-icon-team" />
                Phone
              </li> */}
            {/*   <li>+971561207460</li> */}
            </ul>
          </div>
          <div className={styles.column1}>
            <iframe
              className={styles.map}
              title="kayan"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3609.8296308258423!2d55.27468708567244!3d25.208967337410638!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3e5f428853023db3%3A0x6e63a9fe6b2d7cfe!2zQXNwaW4gQ29tbWVyY2lhbCBUb3dlciAtIDEwNiDYtNin2LHYuSDYp9mE2LTZitiuINiy2KfZitivIC0g2KfZhNmF2LHZg9iyINin2YTYqtis2KfYsdmK2KfZhNmF2LHZg9iyINin2YTYqtis2KfYsdmKINin2YTYo9mI2YTZiiAtINiv2KjZiiAtINin2YTYpdmF2KfYsdin2Kog2KfZhNi52LHYqNmK2Kkg2KfZhNmF2KrYrdiv2Kk!5e0!3m2!1sar!2s!4v1631637355304!5m2!1sar!2s"
              allowfullscreen=""
              loading="lazy"
            />
          </div>
        </div>
      
      </div>
      <Footer />
    </>
  );
};

export default OurTeam;
